export const getWordsInText = (text: string) => {
    const textArr = text.split(' ');

    return textArr.length;
};

export const truncateTextByWords = (text: string, maxWords: number) => {
    const textArr = text.split(' ');

    const slicedTextArr = textArr.slice(0, maxWords);

    return slicedTextArr.join(' ') + '...';
};

export const capitalizeFirstLetter = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
